import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';

import { getCustomerAccessList } from '@digital-platform/shared/domain';
import { LoginSessionFacadeService } from '@digital-platform/users/services';
import {
  SpecialWasteProfileModel,
  WasteProfile
} from '@digital-platform/waste-profiles/domain';
import { WasteProfilesFacadeService } from '../waste-profiles-facade/waste-profiles-facade.service';

@Injectable({
  providedIn: 'root'
})
export class WasteProfilesFactoryGuard implements CanActivate {
  constructor(
    private facade: WasteProfilesFacadeService,
    private loginSessionFacade: LoginSessionFacadeService,
    private router: Router
  ) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<true | UrlTree> {
    return this.loginSessionFacade.loginSession$.pipe(
      filter(session => session !== null),
      take(1),
      map(loginSession => getCustomerAccessList(loginSession.user?.access)),
      tap(customers => {
        let wasteProfile: WasteProfile;
        if (customers[0] && customers[0] !== '' && customers[0] !== '*') {
          wasteProfile = {
            ...SpecialWasteProfileModel.DEFAULT_CONFIG,
            customerName: customers[0]
          };
        } else {
          wasteProfile = {
            ...SpecialWasteProfileModel.DEFAULT_CONFIG
          };
        }

        this.facade.setActive(wasteProfile);
      }),
      map(() => {
        if (next.data.redirectTo) {
          const route = [
            ...next.pathFromRoot
              .map(item =>
                item.url
                  .map(segment => segment.toString())
                  .filter(segment => !!segment)
                  .join('/')
              )
              .filter(item => !!item),
            next.data.redirectTo
          ].join('/');

          return this.router.parseUrl(route);
        }

        return true;
      })
    );
  }
}
